import styled from 'styled-components';
import {Button as MuiButton} from '@mui/material';

const Button = styled(MuiButton)<{marginTop?: string}>`
  margin-top: ${props => props.marginTop ?? '1rem'};
`;
export default Button;
